function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
/**
 * Base Error Class for the CVSDK.
 *
 * Errors that extend CvsdkError must also set their prototype like
 *      Object.setPrototypeOf(this, ExtendedErrorClassName.prototype);
 * in order to use instanceof properly.
 */ export var CvsdkError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(CvsdkError, Error1);
    function CvsdkError(/** A concatenated string indicating the identity of the error, containing information such as VSF/VPF, type of content, specific failure, etc. */ code, /** Text description of the error encountered */ message, /** Whether the error is fatal or a warning */ severity, /** Any additional information regarding the error. */ cause, /** Playback stage where Error occurred (e.g. VSF, VPF, CsaiAdBreak, etc.) */ category, /** Enum that captures the root cause of the Error, if available. */ reason, /** Any additional relevant contextual information around the error, such as network request information. */ parameters, /** The original severity, if it was changed by the CVSDK during the matriculation of the Error object. */ originalSeverity) {
        _class_call_check(this, CvsdkError);
        var _this;
        _this = _call_super(this, CvsdkError, [
            message
        ]), _define_property(_this, "code", void 0), _define_property(_this, "message", void 0), _define_property(_this, "severity", void 0), _define_property(_this, "cause", void 0), _define_property(_this, "category", void 0), _define_property(_this, "reason", void 0), _define_property(_this, "parameters", void 0), _define_property(_this, "originalSeverity", void 0), _this.code = code, _this.message = message, _this.severity = severity, _this.cause = cause, _this.category = category, _this.reason = reason, _this.parameters = parameters, _this.originalSeverity = originalSeverity;
        Object.setPrototypeOf(_this, CvsdkError.prototype);
        // restore prototype chain
        _this.name = "CvsdkError: ".concat(_this.code);
        return _this;
    }
    _create_class(CvsdkError, null, [
        {
            key: "from",
            value: /** Create a CvsdkError from an object of parameters rather than parameters */ function from(param) {
                var code = param.code, message = param.message, severity = param.severity, cause = param.cause, category = param.category, reason = param.reason, parameters = param.parameters, originalSeverity = param.originalSeverity;
                return new CvsdkError(code, message, severity, cause, category, reason, parameters, originalSeverity);
            }
        }
    ]);
    return CvsdkError;
}(_wrap_native_super(Error));

//# sourceMappingURL=error.js.map